<div class="table-wrapper w-100" [ngClass]="{ 'table-wrapper-simple': isSimple }">
  <div
    class="table-filter w-100 d-flex align-items-center justify-content-between flex-column flex-start"
    [ngClass]="{ 'machine-performance-filter': type === 'machines_performance' }"
  >
    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between w-100">
      @if (showTitle) {
        <h3 class="text-left align-self-center mb-md-2 w-100">
          {{ 'TABLE.TITLE.' + tableType | translate }}
        </h3>
      }

      @if (
        !useInlineKeywordFilter &&
        (tableType === 'user' ||
          tableType === 'partner' ||
          tableType === 'required_document' ||
          tableType === 'sales_order' ||
          tableType === 'learning' ||
          tableType === 'banner' ||
          tableType === 'company_group') &&
        hasKeywordFilter
      ) {
        <div class="user-keyword-filter mt-2 mt-md-0 w-100 w-md-auto">
          <div class="input-group w-100">
            <input
              type="text"
              class="form-control filter-input-keyword"
              [placeholder]="keywordFilterPlaceholder | translate"
              [(ngModel)]="keywordSearchValue"
              (ngModelChange)="onKeywordSearch($event)"
            />
          </div>
        </div>
      }
    </div>

    @if (tableConfig.available_filters.length > 0) {
      <app-filters
        ngClass="w-100 w-md-auto"
        [fields]="fields"
        [sortingOptions]="sortingOptions"
        [canOrder]="canOrder"
        [translateOptions]="translateOptions"
        [tableType]="tableType"
        [filters]="filtersTmp$ | async"
        [hasKeywordFilter]="hasKeywordFilter"
        [useInlineKeywordFilter]="useInlineKeywordFilter"
        [keywordFilterName]="keywordFilterName"
        [keywordFilterPlaceholder]="keywordFilterPlaceholder"
        [initialFilters]="currentFilters"
        (selectedFilters)="onSelectedFilter($event)"
        (resetFilters)="resetFilters()"
      />
    }
  </div>

  @if (!isReady || isExternalLoading) {
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status"></div>
    </div>
  } @else {
    <ng-content select="[optionalContent]" />
    @if (type === 'machines_performance' && values) {
      <h3 class="fw-semibold my-0 py-0">{{ 'TABLE.TITLE.mission_data' | translate }}</h3>
      <hr />
    }
    <div class="w-100" [ngClass]="tableConfig.showHeading && !tableConfig.css.table.simple ? 'mt-4' : 'mt-2'">
      <div class="w-100 h-100 table-container">
        @if (tableConfig.showHeading && type !== 'learning') {
          <div
            [ngClass]="{
              'header-wrapper': isStripedTable && !isInnerTable,
              'less-padding': isStripedTable && !isInnerTable && type === 'machines_performance'
            }"
            class="d-none d-lg-block"
          >
            <app-table-row
              [tableHeadings]="tableHeadingsKeys"
              [isHeading]="true"
              [entityType]="tableType"
              [isStripedTable]="isStripedTable"
              [isSimple]="isSimple"
              [headerPrefix]="tableConfig.headerPrefix || ''"
              [columnConfig]="tableConfig.headings!"
            />
          </div>
        }
        @if (values; as rows) {
          <div>
            @if (rows.length > 0) {
              <div>
                <!-- Learning Card Grid Layout -->
                @if (type === 'learning') {
                  <div class="learning-grid-container">
                    <div class="learning-grid">
                      @for (row of rows; track row) {
                        <app-learning-card [learning]="row" />
                      }
                    </div>
                    <!-- Pagination -->
                    @if (prevPage || nextPage) {
                      <div class="d-flex justify-content-end mt-3">
                        <nav>
                          <ul class="pagination">
                            <li>
                              <button
                                (click)="goToPage(prevPage)"
                                [disabled]="!prevPage || isLoadingPaginate"
                                class="pagination-btn"
                                [class.disabled]="!prevPage || isLoadingPaginate"
                              >
                                <img src="../../../../assets/icon/back.svg" alt="" />
                              </button>
                            </li>
                            <li class="page-item">
                              @if (isLoadingPaginate) {
                                <div class="spinner-border spinner-border-sm" role="status"></div>
                              } @else {
                                {{ currentPage }}
                              }
                              @if (totalPages) {
                                <span> / {{ totalPages }}</span>
                              }
                            </li>
                            <li>
                              <button
                                (click)="goToPage(nextPage)"
                                [disabled]="!nextPage || isLoadingPaginate"
                                class="pagination-btn"
                                [class.disabled]="!nextPage || isLoadingPaginate"
                              >
                                <img src="../../../../assets/icon/forward.svg" alt="" />
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    }
                  </div>
                } @else {
                  <div
                    [ngClass]="[
                      isStripedTable && !isInnerTable
                        ? 'body-wrapper body-wrapper-bg' + (isLight ? '-light' : '-dark')
                        : '',
                      type === 'machines_performance' ? 'less-padding' : ''
                    ]"
                  >
                    @for (row of rows; track row; let i = $index) {
                      <app-table-row
                        [values]="row"
                        [isHeading]="false"
                        [hasButton]="tableConfig.hasButton"
                        [tableHeadings]="tableHeadingsKeys"
                        [entityType]="tableType"
                        [isOdd]="i % 2 !== 0"
                        [isStripedTable]="isStripedTable"
                        [isSimple]="isSimple"
                        [headerPrefix]="tableConfig.headerPrefix || ''"
                        (deleteRequested)="onDeleteRequested($event)"
                      />
                    }
                    <!-- Pagination -->
                    @if (prevPage || nextPage) {
                      <div class="d-flex justify-content-end mt-3">
                        <nav>
                          <ul class="pagination">
                            <li>
                              <button
                                (click)="goToPage(prevPage)"
                                [disabled]="!prevPage || isLoadingPaginate"
                                class="pagination-btn"
                                [class.disabled]="!prevPage || isLoadingPaginate"
                              >
                                <img src="../../../../assets/icon/back.svg" alt="" />
                              </button>
                            </li>
                            <li class="page-item">
                              @if (isLoadingPaginate) {
                                <div class="spinner-border spinner-border-sm" role="status"></div>
                              } @else {
                                {{ currentPage }}
                              }
                              @if (totalPages) {
                                <span> / {{ totalPages }}</span>
                              }
                            </li>
                            <li>
                              <button
                                (click)="goToPage(nextPage)"
                                [disabled]="!nextPage || isLoadingPaginate"
                                class="pagination-btn"
                                [class.disabled]="!nextPage || isLoadingPaginate"
                              >
                                <img src="../../../../assets/icon/forward.svg" alt="" />
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    }
                  </div>
                }
                <!-- Standard Table Rows -->
              </div>
            } @else {
              <div class="no-results-container" [ngClass]="isLight ? 'light' : 'dark'">
                {{ 'TABLE.MESSAGES.NO_RESULTS' | translate }}
                {{ 'TABLE.MESSAGES.' + type | translate }}
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (showDeleteConfirm) {
    <div
      class="modal-overlay d-flex align-items-center justify-content-center"
      (click)="cancelDelete()"
      (keydown.escape)="cancelDelete()"
      role="presentation"
    >
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
      <div
        class="modal-content"
        (click)="$event.stopPropagation()"
        role="dialog"
        aria-labelledby="tableDeleteModalTitle"
        aria-modal="true"
        tabindex="-1"
      >
        <div class="modal-header">
          <h5 class="modal-title" id="tableDeleteModalTitle">{{ 'TABLE.DELETE_CONFIRM.TITLE' | translate }}</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="cancelDelete()"
            (keydown.enter)="cancelDelete()"
            (keydown.space)="$event.preventDefault(); cancelDelete()"
          ></button>
        </div>
        <div class="modal-body">
          <p class="mb-0">{{ 'TABLE.DELETE_CONFIRM.MESSAGE' | translate }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="cancelDelete()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="button" class="btn btn-danger" (click)="confirmDelete()">
            {{ 'TABLE.DELETE_CONFIRM.CONFIRM_BUTTON' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
